export enum UploadDomain {
  ADMIN_PRIVATE_FILES = 'ADMIN_PRIVATE_FILES',
  ADMIN_PUBLIC_FILES = 'ADMIN_PUBLIC_FILES',
  ADMIN_VIDEOS = 'ADMIN_VIDEOS',
  INTERNAL_PUBLIC_FILES = 'INTERNAL_PUBLIC_FILES',
}
